var _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadGooglePlayEnUs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 53.333,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1300 0H50C22.5 0 0 22.5 0 50v300c0 27.5 22.5 50 50 50h1250c27.5 0 50-22.5 50-50V50c0-27.5-22.5-50-50-50",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 53.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300 400H50c-27.5 0-50-22.5-50-50V50C0 22.5 22.5 0 50 0h1250c27.5 0 50 22.5 50 50v300c0 27.5-22.5 50-50 50zm0-7.996c23.16 0 42-18.844 42-42.004V50c0-23.16-18.84-42.004-42-42.004H50C26.84 7.996 8.004 26.84 8.004 50v300c0 23.16 18.836 42.004 41.996 42.004h1250",
    style: {
      fill: "#a2a2a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 53.333)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(1.33333 0 0 1.33333 54.721 17.333)",
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "8.38px",
      fontFamily: "ProductSans",
      InkscapeFontSpecification: "ProductSans-Regular",
      writingMode: "lr-tb",
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.8798785 11.588861 16.282219 18.292965 20.438473 25.131832 26.974602 33.930656",
    y: 0
  }, "GET IT ON"))), /*#__PURE__*/React.createElement("path", {
    d: "M473.676 302.047h-29.031v-7.188h21.75c-.579-5.859-2.922-10.468-6.86-13.812-3.937-3.344-8.953-5.016-14.89-5.016-6.532 0-12.063 2.25-16.579 6.766-4.437 4.609-6.687 10.297-6.687 17.156 0 6.875 2.25 12.563 6.687 17.156 4.516 4.532 10.047 6.782 16.579 6.782 3.343 0 6.515-.578 9.453-1.844 2.922-1.25 5.265-3 7.109-5.266l5.516 5.516c-2.5 2.844-5.688 5.031-9.61 6.625-3.937 1.578-8.047 2.328-12.468 2.328-8.704 0-16.079-3-22.094-9.031-6.031-6.031-9.047-13.469-9.047-22.266 0-8.781 3.016-16.234 9.047-22.25 6.015-6.031 13.39-9.047 22.094-9.047 9.109 0 16.39 2.938 22 8.875 4.937 4.938 7.453 11.625 7.453 20 0 1.422-.172 2.938-.422 4.516zm11.566 27.875V270h34.969v7.359H492.93v19h24.609v7.204H492.93v18.984h27.281v7.375zm84.246-7.375v7.375h-41.172v-7.375h16.735V270h7.687v52.547zm37.571 7.375h-7.688V270h7.688zm50.925-7.375v7.375h-41.171v-7.375h16.734V270h7.687v52.547zm77.985-.406c-5.938 6.109-13.219 9.109-21.922 9.109-8.703 0-15.984-3-21.922-9.031-5.937-5.938-8.875-13.391-8.875-22.266 0-8.859 2.938-16.312 8.875-22.25 5.938-6.031 13.219-9.047 21.922-9.047 8.625 0 15.984 3.016 21.922 9.047 5.953 5.938 8.875 13.391 8.875 22.25 0 8.797-2.922 16.235-8.875 22.188zm-38.328-5.032c4.437 4.532 9.875 6.782 16.406 6.782 6.531 0 11.969-2.25 16.328-6.782 4.422-4.437 6.609-10.203 6.609-17.156 0-6.937-2.187-12.719-6.609-17.156-4.359-4.516-9.797-6.766-16.328-6.766-6.531 0-11.969 2.25-16.406 6.766-4.344 4.531-6.516 10.219-6.516 17.156 0 6.953 2.172 12.641 6.516 17.156zm65.797-9.781-.329 11.547h.329L793.906 270h8.032v59.922h-7.704v-35.063l.344-11.546h-.344l-29.125 46.609h-9.359V270h7.688z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.13333 0 0 -.13333 0 53.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.36 100h18.66v125.016h-18.66zm168.07 79.98-21.39-54.199h-.64l-22.2 54.199h-20.1l33.3-75.75-18.99-42.14h19.46l51.31 117.89Zm-105.83-65.781c-6.1 0-14.63 3.059-14.63 10.617 0 9.649 10.62 13.348 19.78 13.348 8.2 0 12.07-1.766 17.05-4.18-1.45-11.582-11.42-19.785-22.2-19.785zm2.26 68.516c-13.51 0-27.5-5.953-33.29-19.141l16.56-6.914c3.54 6.914 10.13 9.164 17.05 9.164 9.65 0 19.46-5.785 19.62-16.082v-1.285c-3.38 1.93-10.62 4.824-19.46 4.824-17.86 0-36.03-9.808-36.03-28.144 0-16.727 14.64-27.504 31.04-27.504 12.54 0 19.47 5.629 23.8 12.226h.65v-9.656h18.02v47.934c0 22.195-16.58 34.578-37.96 34.578zm-115.32-17.953H992v42.851h26.54c13.95 0 21.87-11.547 21.87-21.425 0-9.688-7.92-21.426-21.87-21.426zm-.48 60.254h-44.712V100H992v47.363h26.06c20.68 0 41.01 14.969 41.01 38.825 0 23.851-20.33 38.828-41.01 38.828zm-243.814-110.84c-12.891 0-23.68 10.797-23.68 25.613 0 14.988 10.789 25.938 23.68 25.938 12.727 0 22.715-10.95 22.715-25.938 0-14.816-9.988-25.613-22.715-25.613zm21.426 58.804h-.645c-4.187 4.993-12.246 9.504-22.39 9.504-21.27 0-40.762-18.691-40.762-42.695 0-23.84 19.492-42.367 40.762-42.367 10.144 0 18.203 4.512 22.39 9.664h.645v-6.117c0-16.278-8.699-24.973-22.715-24.973-11.434 0-18.523 8.215-21.426 15.14l-16.269-6.765c4.668-11.273 17.07-25.133 37.695-25.133 21.914 0 40.441 12.89 40.441 44.309v76.359h-17.726ZM826.289 100h18.68v125.016h-18.68zm46.231 41.242c-.481 16.434 12.734 24.809 22.234 24.809 7.414 0 13.691-3.707 15.793-9.02zm57.996 14.18c-3.543 9.5-14.336 27.062-36.407 27.062-21.914 0-40.117-17.238-40.117-42.531 0-23.844 18.047-42.531 42.207-42.531 19.492 0 30.774 11.918 35.449 18.848l-14.5 9.668c-4.835-7.09-11.437-11.762-20.949-11.762-9.5 0-16.269 4.351-20.613 12.89l56.863 23.52zm-453.078 14.012v-18.043h43.175c-1.289-10.149-4.672-17.559-9.828-22.715-6.285-6.281-16.113-13.211-33.347-13.211-26.583 0-47.364 21.426-47.364 48.008 0 26.582 20.781 48.011 47.364 48.011 14.339 0 24.808-5.64 32.542-12.89l12.731 12.73c-10.797 10.309-25.133 18.203-45.273 18.203-36.415 0-67.024-29.644-67.024-66.054 0-36.407 30.609-66.051 67.024-66.051 19.652 0 34.476 6.445 46.074 18.527 11.922 11.922 15.629 28.676 15.629 42.211 0 4.184-.325 8.051-.969 11.274zm110.789-55.258c-12.891 0-24.008 10.633-24.008 25.777 0 15.305 11.117 25.774 24.008 25.774 12.886 0 24.003-10.469 24.003-25.774 0-15.144-11.117-25.777-24.003-25.777zm0 68.308c-23.528 0-42.696-17.882-42.696-42.531 0-24.488 19.168-42.531 42.696-42.531 23.519 0 42.691 18.043 42.691 42.531 0 24.649-19.172 42.531-42.691 42.531zm93.128-68.308c-12.882 0-24.003 10.633-24.003 25.777 0 15.305 11.121 25.774 24.003 25.774 12.891 0 24.004-10.469 24.004-25.774 0-15.144-11.113-25.777-24.004-25.777zm0 68.308c-23.519 0-42.687-17.882-42.687-42.531 0-24.488 19.168-42.531 42.687-42.531 23.528 0 42.696 18.043 42.696 42.531 0 24.649-19.168 42.531-42.696 42.531",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 53.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.172 205.758-106.465-113c.004-.024.012-.043.016-.067 3.265-12.27 14.472-21.304 27.773-21.304a28.646 28.646 0 0 1 14.59 3.96l.34.2 119.84 69.152-56.094 61.059",
    style: {
      fill: "#eb3131",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 53.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.883 225-.102.07-51.738 29.993-58.289-51.868 58.492-58.484 51.465 29.695c9.023 4.871 15.148 14.383 15.148 25.352 0 10.89-6.043 20.355-14.976 25.242",
    style: {
      fill: "#f6b60b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 53.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.703 307.227a28.183 28.183 0 0 1-.976-7.399V100.152c0-2.562.332-5.043.98-7.394l110.129 110.109-110.133 104.36",
    style: {
      fill: "#5778c5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 53.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.957 199.992 55.106 55.09-119.704 69.402a28.823 28.823 0 0 1-14.863 4.11c-13.301 0-24.523-9.051-27.789-21.336-.004-.012-.004-.02-.004-.031l107.254-107.235",
    style: {
      fill: "#3bad49",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 53.333)"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadGooglePlayEnUs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download_google_play_EN_US.a50374f8ac612aa570c2e79119fdf54b.svg";